enum PlatformIntegrationCategory {
  CARD_ISSUING = "CARD_ISSUING",
  ACQUIRING = "ACQUIRING",
}

export default PlatformIntegrationCategory;
